import React, { useEffect } from 'react';
import { ThemeProvider } from 'flowbite-react';
import { DataManagerProvider } from './DataManagerContext';
import Router from './router';
import './styles.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { SnackbarProvider } from 'notistack';
import "aws-amplify/auth/enable-oauth-listener";
import { chronomapTheme } from './theme/flowbiteTheme';

const App: React.FC = () => {
  // Respect system preference, but allow user override via localStorage
  useEffect(() => {
    const root = document.documentElement;
    const stored = localStorage.getItem('chronomap-theme');

    if (stored === 'dark' || stored === 'light') {
      root.classList.toggle('dark', stored === 'dark');
    } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      // Only follow system if user hasn't set an explicit preference
      if (!localStorage.getItem('chronomap-theme')) {
        root.classList.toggle('dark', e.matches);
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <ThemeProvider theme={chronomapTheme} applyTheme="replace">
      <Authenticator.Provider>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <DataManagerProvider>
            <Router />
          </DataManagerProvider>
        </SnackbarProvider>
      </Authenticator.Provider>
    </ThemeProvider>
  );
};

export default App;
